import { createRouter, createWebHistory } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/app/stores/user.js'
import { PUBLIC_ROUTE_NAMES } from '../constants'

const Login = () => import('@/app/pages/Login.vue')
const Xards = () => import('@/app/pages/Xards.vue')
const LinkXard = () => import('@/app/pages/LinkXard.vue')
const NotFound = () => import('@/app/pages/NotFound.vue')

export const routes = [
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'xards',
    path: '',
    component: Xards
  },
  {
    name: 'link_xard',
    path: '/xards/:id/link',
    component: LinkXard,
    props: true
  },
  {
    name: 'xards_filters',
    path: '/xards/:filters?',
    component: Xards,
    props: true
  },
  {
    name: 'not_found',
    path: '/:catchAll(.*)*',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(_, __, savedPosition) {
    return savedPosition ? savedPosition : null
  }
})

// router.beforeResolve(to => {
//   console.log("to: ", to)
//   window.to = to
//   if (to.hash && to.hash.includes('#ftxard')) {
//     return false
//   }
//   return true
// })

router.beforeEach(async to => {
  // const nearestWithTitle = to.matched
  //   .slice()
  //   .reverse()
  //   .find(r => r.meta && r.meta.title)
  // document.title = nearestWithTitle?.meta?.title || PAGE_TITLE

  if (PUBLIC_ROUTE_NAMES.includes(to.name)) {
    return
  }

  const userStore = useUserStore()
  const result = await userStore.checkUser()
  if (result) {
    return
  }

  return { name: 'login' }
})

export default router
